import { CR_API_ENDPOINTS } from '../constants';
import { BatteryBrand } from '../types';
import { apiService } from './api.service';

class BatteryBrandsService {
  async getAllBatteryBrands(): Promise<BatteryBrand[]> {
    return apiService.get<BatteryBrand[]>(CR_API_ENDPOINTS.BATTERY_BRANDS);
  }

  async getBatteryBrandById(id: string): Promise<BatteryBrand> {
    return apiService.get<BatteryBrand>(`${CR_API_ENDPOINTS.BATTERY_BRANDS}/${id}`);
  }

  async createBrand(brandData: {
    name: string;
  }): Promise<BatteryBrand> {
    return apiService.post<BatteryBrand>(CR_API_ENDPOINTS.BATTERY_BRANDS, brandData);
  }
}

export const batteryBrandsService = new BatteryBrandsService();